import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { EnvironmentProvider } from "./context/EnvironmentContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AppLayout from "./components/layout/AppLayout";
import LoginPage from "./pages/Login/LoginPage";
import UsagePage from "./pages/Usage/UsagePage";
import NotFound from "./pages/NotFound/NotFound";
import SqAiPage from "./labs/sq-ai/SqAiPage";
import ComparePage from "./labs/sq-ai/ComparePage";
import "./App.css";

// Phase-1 (sq-ai standalone): the SQ-AI chat page is the single surface — login lands
// there and it's the only one linked in the UI. Gating is ProtectedRoute (token-only);
// the RBAC PermissionRoute was dropped with the RBAC layer. There is no SQL console: the
// agent never writes SQL, and no screen runs it either (docs/DECISIONS.md K-FN2-1, K-PV2-7).
export default function App() {
  return (
    <AuthProvider>
      <EnvironmentProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />

          {/* SQ-AI chat — the primary (and only linked) surface; full-screen, own layout */}
          <Route
            path="/sq-ai"
            element={
              <ProtectedRoute>
                <SqAiPage />
              </ProtectedRoute>
            }
          />

          {/* Compare panes — a DEVELOPER screen (PN1): one question asked of three model
              configurations side by side. Unlinked like /usage; full-screen, own layout. The server
              refuses its model override unless SQ_AI_COMPARE_PANES is on. */}
          <Route
            path="/compare"
            element={
              <ProtectedRoute>
                <ComparePage />
              </ProtectedRoute>
            }
          />

          {/* The admin shell (env switcher + header) for the unlinked development views. */}
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            {/* Credit usage for the signed-in user — a DEVELOPMENT view, unlinked. The admin
                console the pricing deck describes is Phase 2 and needs an admin role this build
                has no concept of. */}
            <Route path="/usage" element={<UsagePage />} />
          </Route>

          {/* Legacy landing → chat */}
          <Route path="/home" element={<Navigate to="/sq-ai" replace />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </EnvironmentProvider>
    </AuthProvider>
  );
}
